export default __webpack_public_path__ + "static/media/sm-Circle.5365bf36.svg";